export default __webpack_public_path__ + "static/media/fade-star-icon.ba6ece46.svg";